import { Box, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import explorosLogo from '../../../../assets/resources/exploros_logo.svg';
import { signupHeaderStyles } from './SignupHeader.styles';

interface SignupHeaderProps {
  title: string;
  description: string;
  logoSrc?: string;
  logoAlt?: string;
  isProductLogo?: boolean;
  isCentered?: boolean;
}

export function SignupHeader({title, description, logoSrc = explorosLogo, logoAlt = 'Exploros', isProductLogo = false, isCentered = false}: SignupHeaderProps) {
  const theme = useTheme();

  return (
    <>
      <Box component="header" sx={signupHeaderStyles.logoHeader()}>
        <Box component="img" src={logoSrc} alt={logoAlt} sx={isProductLogo ? signupHeaderStyles.productLogo() : signupHeaderStyles.logo()} />
      </Box>
      <Box sx={signupHeaderStyles.intro(isCentered)}>
        <Typography component="h1" sx={signupHeaderStyles.title()}>{title}</Typography>
        <Typography sx={signupHeaderStyles.subtitle(theme)}>{description} Already have an account? <Link href="/login" sx={signupHeaderStyles.accentLink(theme)}>Log in</Link></Typography>
      </Box>
    </>
  );
}
